import Courses from "./api/coursesAPI";

export default {
  Courses,
};
